import React from 'react'

import cn from 'classnames'

import { Icon } from 'src/components/ui'

import styles from './InfoItem.module.scss'

interface Props {
  title: string
  className?: string
}

const InfoItem: React.FC<Props> = ({ title, className }) => {
  return (
    <div className={cn(styles.item, className)}>
      <Icon name='delete-data' />
      <p>{title}</p>
    </div>
  )
}

export default InfoItem
